/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_FlavorsInputs */

const en_search_flavors = /** @type {(inputs: Search_FlavorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search flavors...`)
};

const es_search_flavors = /** @type {(inputs: Search_FlavorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar sabores...`)
};

/**
* | output |
* | --- |
* | "Search flavors..." |
*
* @param {Search_FlavorsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_flavors = /** @type {((inputs?: Search_FlavorsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_FlavorsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_flavors(inputs)
	return es_search_flavors(inputs)
});